export function loadYouTubeAPI() {
  const url = 'https://www.youtube.com/player_api';

  if (!document.querySelector(`script[src="${url}"]`)) {
    let tag = document.createElement('script');
    tag.src = url;

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    console.log('YouTube API loaded!');
  } else {
    console.log('YouTube API already loaded');
  }
}
